import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import PageNotFound from './pageNotFound';
import Login from './components/auth/login/login';
import RedirectUrl from './components/auth/redirectUrl/RedirectUrl';
import UserContainer, { UserRoute } from './components/user/userContainer';
import SignUp from './components/auth/Signup/SignUp';
import ForgetPassword from './components/auth/ForgetPassword/ForgetPassword';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import UserGuard from './components/shared/user.guard';
import DisconnectedPage from './components/auth/disconnected';
import AdminContainer from './components/admin/adminContainer';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, persistor } from './store';
import { Button, Stack, Typography } from '@mui/material';
import { initializeApp } from './app.init';
import { LocalStorageKey } from './components/shared/auth.functions';

export enum MainRoute {
  IntuitRedirect = '/intuit-signin-redirect-url',
  User = '/user',
  Admin = '/admin',
  SignIn = '/signin',
  SignUp = '/signup',
  ForgotPassword = '/forget-password',
  DisconnectedPage = '/disconnected'
}

export default function App() {
  const dispatch = useDispatch();
  const loading = useSelector((s: RootState) => s.app.loading);
  const error = useSelector((s: RootState) => s.app.error);
  const initialized = useSelector((s: RootState) => s.app.initialized);

  const hasTokens = Boolean(localStorage.getItem(LocalStorageKey.ACCESS_TOKEN));

  useEffect(() => {
    if (hasTokens) {
      dispatch(initializeApp() as any);
    }
  }, []);

  // Пока есть токен, но приложение не инициализировано — показываем лоадер
  if (hasTokens && (loading || !initialized)) {
    return (
      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} />
        {error && !loading ? (
          <Stack spacing={2} sx={{ p: 3, maxWidth: 480 }} role="alert">
            <Typography variant="h6">Unable to load your account</Typography>
            <Typography>Please try again or sign in with another account.</Typography>
            <Button variant="contained" onClick={() => dispatch(initializeApp() as any)}>Retry</Button>
            <Button onClick={async () => {
              persistor.pause();
              await persistor.purge();
              localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
              localStorage.removeItem(LocalStorageKey.REFRESH_TOKEN);
              window.location.replace(MainRoute.SignIn);
            }}>Sign out</Button>
          </Stack>
        ) : <div style={{ padding: 24 }}>Loading...</div>}
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route
          path="/"
          element={
            <UserGuard>
              <Navigate to={MainRoute.User + UserRoute.Clients} />
            </UserGuard>
          }
        />
        <Route path={MainRoute.IntuitRedirect} element={<RedirectUrl />} />
        <Route
          path={MainRoute.Admin + '/*'}
          element={
            <UserGuard>
              <AdminContainer />
            </UserGuard>
          }
        />
        <Route
          path={MainRoute.User + '/*'}
          element={
            <UserGuard>
              <UserContainer />
            </UserGuard>
          }
        />
        <Route path={MainRoute.SignIn} element={<Login />} />
        <Route path={MainRoute.SignUp} element={<SignUp />} />
        <Route path={MainRoute.ForgotPassword} element={<ForgetPassword />} />
        <Route path={MainRoute.DisconnectedPage} element={<DisconnectedPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
